
import { SxProps, Theme } from "@mui/material";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { ActionMenuItem } from "../action-menu/ActionMenuItem";
import { ViewOptionStateEnum } from "./ViewOptionStateEnum";
import { IOrganization } from "../../services/organization-data-service/Models";
import { INavigationItem } from "../../services/navigation-data-service/Models";
import { useEvaluateFeature } from "../../queries/features/UseEvaluateFeature";
import { FeatureConstants } from "../../services/features-data-service/Models";
import ContextualAppBarV1 from "./ContextualAppBarV1";
import ContextualAppBarV2 from "./ContextualAppBarV2";

export type ContextualAppBarProps = {
    viewOptionState?: ViewOptionStateEnum;
    onExecuteAction?: (action: ActionMenuItem) => void;
    getRefreshAction?: () => ActionMenuItem;
    actions?: ActionMenuItem[];
    configurationActions?: ActionMenuItem[];
    hideBreadcrumb?: boolean;
    showOrganizationPicker?: boolean;
    onOrganizationSelected?: (item: IOrganization) => void;
    organizationID?: number;

    showGroupPicker?: boolean;
    onGroupSelected?: (item: INavigationItem) => void;
    groupID?: number;
    hideOptionsAction?: boolean;
    dense?: boolean;
    label?: string;
    viewMaximized?: boolean;

    onOverrideViewOptionsClick?: () => void;
    hideMaximizeViewAction?: boolean;

    sx?: SxProps<Theme>;
    onGoingBack?: () => boolean;
};

export default function ContextualAppBar({
    onExecuteAction,
    getRefreshAction,
    actions,
    configurationActions,
    viewOptionState,
    hideBreadcrumb,
    showOrganizationPicker,
    onOrganizationSelected,
    organizationID,
    showGroupPicker,
    onGroupSelected,
    groupID,
    hideOptionsAction,
    dense,
    label,
    viewMaximized,
    onOverrideViewOptionsClick,
    hideMaximizeViewAction,
    sx,
    onGoingBack
}: ContextualAppBarProps) {


    const { data: headerAndActionsV2Feature } = useQueryNotifications(useEvaluateFeature)({
        feature: FeatureConstants.HeaderAndActionsV2,
    });

    const headerAndActionsV2 = (headerAndActionsV2Feature ?? false);

    return (headerAndActionsV2 ? 
        <ContextualAppBarV2 
            viewOptionState={viewOptionState}
            onExecuteAction={onExecuteAction}
            getRefreshAction={getRefreshAction}
            actions={actions}
            configurationActions={configurationActions}
            hideBreadcrumb={hideBreadcrumb}
            showOrganizationPicker={showOrganizationPicker}
            onOrganizationSelected={onOrganizationSelected}
            organizationID={organizationID}
            showGroupPicker={showGroupPicker}
            onGroupSelected={onGroupSelected}
            groupID={groupID}
            hideOptionsAction={hideOptionsAction}
            dense={dense}
            label={label}
            viewMaximized={viewMaximized}
            onOverrideViewOptionsClick={onOverrideViewOptionsClick}
            hideMaximizeViewAction={hideMaximizeViewAction}
            sx={sx}
            onGoingBack={onGoingBack}
        /> :
        <ContextualAppBarV1 
            viewOptionState={viewOptionState}
            onExecuteAction={onExecuteAction}
            getRefreshAction={getRefreshAction}
            actions={actions}
            configurationActions={configurationActions}
            hideBreadcrumb={hideBreadcrumb}
            showOrganizationPicker={showOrganizationPicker}
            onOrganizationSelected={onOrganizationSelected}
            organizationID={organizationID}
            showGroupPicker={showGroupPicker}
            onGroupSelected={onGroupSelected}
            groupID={groupID}
            hideOptionsAction={hideOptionsAction}
            dense={dense}
            label={label}
            viewMaximized={viewMaximized}
            onOverrideViewOptionsClick={onOverrideViewOptionsClick}
            hideMaximizeViewAction={hideMaximizeViewAction}
            sx={sx}
            onGoingBack={onGoingBack}
        />
    );
}
